import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import AppModalTitle, { AppModalTitleProps } from "@/common/components/Modals/AppModalTitle";

import {
  CustomerAcknowledgementDisplay,
  CustomerAcknowledgementDisplayProps,
} from "./CustomerAcknowledgementDisplay";

type Props = AppModalProps & {
  subProps: CustomerAcknowledgementDisplayProps;
  modelTitleProps?: Partial<AppModalTitleProps>;
};

export function CustomerAcknowledgementDisplayModal({
  subProps,
  modelTitleProps,
  ...modalProps
}: Props) {
  return (
    <AppModal fullWidth maxWidth='lg' {...modalProps}>
      <AppModalTitle
        title='Customer acknowledgement'
        withClose
        onClose={() => modalProps.onClose?.({}, "escapeKeyDown")}
        {...modelTitleProps}
      />

      <AppModalContent>
        <CustomerAcknowledgementDisplay {...subProps} />
      </AppModalContent>
    </AppModal>
  );
}
